<script>
  // A follow-up's condition: "Ask only if [earlier question] [operator] [answer]". The answers on offer come from the
  // chosen question (its stars, scale points, yes/no or choices).
  let { builder, question, sources } = $props()

  const source = $derived(builder.source(question))
  const operators = $derived(source ? builder.operators[source.type] ?? [] : [])
  const choices = $derived(source ? builder.answerChoices(source) : [])

  function pickSource(uid) {
    const picked = sources.find(other => other.uid === Number(uid))
    question.condition = picked ? builder.defaultCondition(picked) : { ...question.condition, sourceUid: null }
  }

  function pickValue(index) {
    question.condition.value = choices[Number(index)]?.value
  }

  function toggleChoice(value, on) {
    const values = new Set(question.condition.value ?? [])
    on ? values.add(value) : values.delete(value)
    question.condition.value = choices.map(choice => choice.value).filter(choice => values.has(choice))
  }
</script>

<div class="space-y-2 text-sm text-gray-700">
  <span class="block">Ask only if</span>
  <div class="flex min-w-0 flex-wrap items-center gap-2">
    <select
      class="input-base min-w-0 flex-1 py-2 pl-3 pr-9 text-sm"
      aria-label="Earlier question"
      value={source?.uid ?? ''}
      onchange={event => pickSource(event.currentTarget.value)}
    >
      {#if !source}<option value="">Pick a question</option>{/if}
      {#each sources as other (other.uid)}
        <option value={other.uid}>{builder.prompt(other)}</option>
      {/each}
    </select>

    {#if source}
      {#if operators.length > 1}
        <select
          class="input-base !w-auto py-2 pl-3 pr-9 text-sm"
          aria-label="Comparison"
          value={question.condition.operator}
          onchange={event => (question.condition.operator = event.currentTarget.value)}
        >
          {#each operators as operator (operator)}
            <option value={operator}>{builder.operatorLabel(source, operator)}</option>
          {/each}
        </select>
      {:else}
        <span>{builder.operatorLabel(source, operators[0])}</span>
      {/if}

      {#if source.type === 'choice'}
        <div class="flex flex-wrap gap-1.5">
          {#each choices as choice (choice.value)}
            {@const on = (question.condition.value ?? []).includes(choice.value)}
            <label
              class="cursor-pointer rounded-full border px-3 py-1 text-sm font-medium
                     {on ? 'border-blue-600 bg-blue-600 text-white' : 'border-gray-200 bg-white text-gray-700'}"
            >
              <input
                type="checkbox"
                class="sr-only"
                checked={on}
                onchange={event => toggleChoice(choice.value, event.currentTarget.checked)}
              />
              {choice.label}
            </label>
          {/each}
        </div>
      {:else}
        <select
          class="input-base !w-auto py-2 pl-3 pr-9 text-sm"
          aria-label="Answer"
          value={String(choices.findIndex(choice => choice.value === question.condition.value))}
          onchange={event => pickValue(event.currentTarget.value)}
        >
          {#each choices as choice, index (choice.label)}
            <option value={String(index)}>{choice.label}</option>
          {/each}
        </select>
      {/if}
    {/if}
  </div>
</div>
